import React from "react";
import Select from "react-select";

const customStyles = (width) => {
  return {
    container: (provided) => ({
      ...provided,
      width: `${width}px`,
    }),
    control: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      width: `${width}px`,
    }),
    valueContainer: (provided) => ({
      ...provided,
    }),
    menu: (provided) => ({
      ...provided,
      width: `${width}px`,
      maxHeight: "140px",
    }),
    menuList: (provided) => ({
      ...provided,
      width: `${width}px`,
      maxHeight: "140px",
    }),
    option: (provided) => ({
      ...provided,
    }),
  };
};

const SelectInput = ({
  name,
  options,
  setSelected,
  selected,
  multiple = false,
  width = 300,
  selectWidth = 260,
  setAccesses,
  labelUp = false,
  showLabel = true,
  onChange = () => {},
  color = "black",
  required = false,
  placeholder = "Select...",
  id,
  disabled = false,
  fontSize = 18,
  margin = "10px",
  requiredSign,
}) => {
  return (
    <div
      style={{
        display: labelUp ? "grid" : "flex",
        alignItems: "center",
        gap: labelUp ? "10px" : "30px",
        margin: margin,
        borderRadius: "20px !important",
      }}
    >
      {showLabel && (
        <label
          style={{
            width: `${width}px`,
            textAlign: "right",
            fontSize: `${fontSize}px`,
          }}
        >
          <strong style={{ color: color }}>
            {name}:{" "}
            {requiredSign ? <span style={{ color: "red" }}>*</span> : ""}
          </strong>
        </label>
      )}
      <div>
        <Select
          id={id}
          value={selected}
          onChange={setSelected}
          options={options}
          isMulti={multiple}
          styles={customStyles(selectWidth)}
          placeholder={placeholder}
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};

export default SelectInput;
